import { createAction, props } from "@ngrx/store";

export const ResetComponentStateAction = createAction("[Start a pension review component] reset component state");
export const SubmitApplicationAction = createAction("[Start a pension review component] submit application", props<{ accountId: number, applicationId: number }>());
export const ApplicationSubmittedAction = createAction("[Start a pension review component] application submitted");